import {formatDateToBR} from "../../../../../utils/time";
import {SETableColumnsProps} from "../../../../components/SETable";
import {Grid, IconButton} from "@mui/material";
import {
  RiCheckboxCircleFill,
  RiCloseCircleFill,
  RiDeleteBin6Line,
  RiErrorWarningFill,
  RiPencilLine,
} from "react-icons/ri";
import React from "react";
import {truncateString} from "../../../../../utils/utils";
import SETableIconButton from "../../../../components/SETable/SETableIconButton";
import {formatStringArray} from "../../../../utils/utils";

interface TableColumnsProps {
  handleEdit?: (data?: any) => void;
  handleUpdateStatus?: (data?: any) => void;
  handleDelete?: (id?: number | string) => void;
}

export const tableColumns = ({
  handleEdit = () => {},
  handleDelete = () => {},
  handleUpdateStatus = () => {},
}: TableColumnsProps): SETableColumnsProps[] => [
  {
    id: "dataCriacao",
    label: "Data",
    width: 50,
    customField: formatDateToBR,
    align: "center",
  },
  {
    id: "uf",
    label: "UF",
    customField: (uf: any) => uf?.sigla,
    align: "center",
  },
  {
    id: "titulo",
    label: "Título",
    customField: (tipo) => (
        <div title={tipo}>
          { truncateString(tipo, 40) }
        </div>
    ),
  },
  {
    id: "tipoAtendente",
    label: "Perfil Atendente",
    customField: formatStringArray
  },
  {
    id: "descricao",
    label: "Descrição",
    customField: (descricao) => (
      <div>
        <div
          dangerouslySetInnerHTML={{ __html: truncateString(descricao, 40) }}
        />
      </div>
    ),
  },
  {
    id: "tipo",
    label: "Tipo",
    align: "center",
    customField: formatStringArray
  },
  {
    id: "status",
    label: "Status",
    align: "center",
    sortable: false,
    width: 300,
    customField: (value: any, row: any) => (
      <Grid container justifyContent="center" alignItems="center">
        <Grid item md={6} container alignItems="center" justifyContent="center">
          <IconButton onClick={() => handleUpdateStatus(row)}>
            <>
              {value === "APROVADO" && (
                <RiCheckboxCircleFill size={26} color="#66BD91" />
              )}
              {value === "PENDENTE" && (
                <RiErrorWarningFill size={26} color="#F6E566" />
              )}
              {value === "REPROVADO" && (
                <RiCloseCircleFill size={26} color="#FF0000" />
              )}
            </>
          </IconButton>
          <SETableIconButton onClick={() => handleEdit(row)}>
            <RiPencilLine size={20} color="#555770" />
          </SETableIconButton>
          <SETableIconButton onClick={() => handleDelete(row.id)}>
            <RiDeleteBin6Line size={20} color="#555770" />
          </SETableIconButton>
        </Grid>
      </Grid>
    ),
  },
];
